import React from 'react'
import { Container, Typography } from '@mui/material'
import ConstructionIcon from '@mui/icons-material/Construction';
import {Box, Button} from '@mui/material';
import { Link } from 'react-router-dom';

export default function UnderDev() {
  return (
    <Container 
      maxWidth="md" 
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        textAlign: 'center'
      }}
    >
      <ConstructionIcon sx={{ fontSize: 100, color: '#BF0A30', mb: 2 }} />
      <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#BF0A30', mb: 2 }}>
        Under Construction
      </Typography>
      <Box>
        <Button 
          component={Link} 
          to="/" 
          variant="contained" 
          sx={{ backgroundColor: '#BF0A30', '&:hover': { backgroundColor: '#a30d26' } }}
        >
          Go to Home
        </Button>
      </Box>
    </Container>
  )
}
